import { Controller } from "@hotwired/stimulus"

import toastr from 'toastr'

// Connects to data-controller="toastr"
export default class extends Controller {
  connect() {
    toastr.options = {
      "closeButton": true,
      "debug": false,
      "newestOnTop": true,
      "progressBar": false,
      "positionClass": "toast-top-right",
      "preventDuplicates": false,
      "onclick": null,
      "showDuration": "300",
      "hideDuration": "5000",
      "timeOut": "10000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    }

    this.element.querySelectorAll('div').forEach(elem => {
      let title = ''
      if (elem.dataset.kind == 'info') { title = 'Informação' }
      if (elem.dataset.kind == 'warning') { title = 'Aviso' }
      if (elem.dataset.kind == 'success') { title = 'Sucesso' }
      if (elem.dataset.kind == 'error') { title = 'Erro' }
      toastr[elem.dataset.kind](elem.dataset.text, title)
    })
  }
}
